import InteractionContent from "components-for/interactions/interaction-content";
import InteractionTitle from "components-for/interactions/interaction-title";
import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { IInteractionDetailsResponse } from "@edgetier/watchtower-types";
import { IProps } from "./interaction.types";
import { SpinnerUntil } from "@edgetier/components";
import { useInteractionDetails } from "hooks-for/interactions/use-interaction-details";
import { useLocation, useParams } from "react-router-dom";
import InteractionOptionsMenu from "components-for/interactions/interaction-options-menu";
import InteractionProvider from "components-for/interactions/interaction-provider";
import "./interaction.scss";

/**
 * Display an individual interaction. This is often used to deep link from an email.
 * @returns Interaction content.
 */
const Interaction: FunctionComponent<IProps> = () => {
    const { interactionId } = useParams<{ readonly interactionId: string }>();
    const { data: interaction, isLoading } = useInteractionDetails(interactionId);
    const { state } = useLocation<{ areWritingIssuesVisible?: boolean }>();

    return (
        <Page className="interaction">
            <SpinnerUntil<IInteractionDetailsResponse> data={interaction} isReady={!isLoading}>
                {(detailedInteraction) =>
                    typeof detailedInteraction === "undefined" ? (
                        "Error"
                    ) : (
                        <InteractionProvider areWritingIssuesVisible={state?.areWritingIssuesVisible}>
                            <PageHeader>
                                <InteractionTitle
                                    contentCleaned={detailedInteraction.contentCleaned}
                                    interactionType={detailedInteraction.interactionType}
                                    startDateTime={detailedInteraction.startDateTime}
                                    subject={detailedInteraction.subject}
                                    languageIsoCode={detailedInteraction.languageIsoCode}
                                    interactionId={detailedInteraction.interactionId}
                                />
                                <InteractionOptionsMenu
                                    interactionId={detailedInteraction.interactionId}
                                    interactionUrl={detailedInteraction.url}
                                    showFullScreenOption={false}
                                />
                            </PageHeader>
                            <PageContent>
                                <InteractionContent
                                    agentId={detailedInteraction.agentId}
                                    interactionId={detailedInteraction.interactionId}
                                    interactionType={detailedInteraction.interactionType}
                                    tags={detailedInteraction.tags}
                                />
                            </PageContent>
                        </InteractionProvider>
                    )
                }
            </SpinnerUntil>
        </Page>
    );
};

export default memo(Interaction);
